import { useMediaQuery } from 'react-responsive';

/**
 * Hook único para decisões responsivas em Screens.
 *
 * Substitui as 22 declarações duplicadas de useMediaQuery espalhadas
 * pelas telas (várias com queries 1024px / 1023px / 1500px, sem
 * convenção unificada) por uma API consistente.
 *
 * Breakpoints alinhados com o que App.js já usa para escolher entre
 * Layouts/Desktop.js e Mobile.js (cutoff 1024px). Subdivide o "mobile"
 * em phone vs tablet para componentes que precisam adaptar mais.
 *
 *   isPhone   → 0–767px       (celular padrão; mínimo suportado 360px)
 *   isTablet  → 768–1023px    (tablet portrait; iPad 9.7" cai aqui)
 *   isDesktop → 1024px+
 *   isMobile  → isPhone || isTablet (= mesmo cutoff do Layouts/Mobile.js)
 *
 * Uso típico nas Screens da Fase 1+ do Mobile revamp:
 *
 *   import { FEATURE_FLAGS } from '../../Config/environment';
 *   import { useResponsive } from '../../Components/hooks/useResponsive';
 *
 *   const HomeScreen = () => {
 *     const { isMobile, isPhone } = useResponsive();
 *     const mobileRevamp = isMobile && FEATURE_FLAGS.MOBILE_REVAMP.HOME;
 *     return <div className={`screen-home ${mobileRevamp ? 'mobile-revamp' : ''}`}>...</div>;
 *   };
 *
 * Origem: plano `.context/plans/2026-06-09-mobile-revamp-execution.md`,
 * Fase 0.
 */
export const useResponsive = () => {
	const isPhone   = useMediaQuery({ maxWidth: 767 });
	const isTablet  = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
	const isDesktop = useMediaQuery({ minWidth: 1024 });
	const isMobile  = isPhone || isTablet;
	return { isPhone, isTablet, isDesktop, isMobile };
};

export default useResponsive;
